/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramOptin } from '../../models/program-optin';
import { UserOptin } from '../../models/user-optin';

export interface PostProgramOptin$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
      body: UserOptin
}

export function postProgramOptin(http: HttpClient, rootUrl: string, params: PostProgramOptin$Params, context?: HttpContext): Observable<StrictHttpResponse<ProgramOptin>> {
  const rb = new RequestBuilder(rootUrl, postProgramOptin.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramOptin>;
    })
  );
}

postProgramOptin.PATH = '/loyalty/programs/{programId}/optin';
